import { Navigate, Outlet } from "react-router-dom";

const STORAGE_KEY = "growing-student-user";

/**
 * localStorage에서 사용자 정보를 확인하여 로그인 상태 판단
 * (httpOnly 쿠키는 JavaScript로 읽을 수 없으므로 localStorage 사용)
 */
function isLoggedIn(): boolean {
  try {
    const userJson = localStorage.getItem(STORAGE_KEY);
    return !!userJson;
  } catch {
    return false;
  }
}

/**
 * 인증 페이지(로그인, 회원가입 등)를 보호하는 컴포넌트
 * 이미 로그인된 사용자는 메인 페이지로 리다이렉트됨
 */
export function AuthGuard() {
  if (isLoggedIn()) {
    return <Navigate to="/main" replace />;
  }

  return <Outlet />;
}
